var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5264 16C13.7356 16 13.8221 15.8185 13.8221 15.6219C13.8221 15.569 13.8221 15.5236 13.8149 15.4707L13.1947 11.69L15.8125 9.01323C15.9062 8.91493 16 8.78639 16 8.65028C16 8.42344 15.7692 8.3327 15.5962 8.30246L11.976 7.75047L10.3534 4.31002C10.2885 4.16635 10.1659 4 10 4C9.83413 4 9.71154 4.16635 9.64663 4.31002L8.02404 7.75047L4.40385 8.30246C4.22356 8.3327 4 8.42344 4 8.65028C4 8.78639 4.09375 8.91493 4.18029 9.01323L6.80529 11.69L6.1851 15.4707C6.17788 15.5236 6.17067 15.569 6.17067 15.6219C6.17067 15.8185 6.26442 16 6.47356 16C6.57452 16 6.66827 15.9622 6.76202 15.9093L10 14.1248L13.238 15.9093C13.3245 15.9622 13.4255 16 13.5264 16Z",
    fill: "#FCD559"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.937255 0 0 0 0 0.768627 0 0 0 0 0.290196 0 0 0 0.530239 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon-star.9e058bfc5e14ac9e63f7b6d295c1101a.svg";
export { ForwardRef as ReactComponent };